import { Component, OnInit } from '@angular/core';
import { UserService, AdministrationService } from '../../../services';
import { User } from '../../../models';
import { Utils } from '../../../utils';
import { MessageService } from 'primeng/api';
import { UsersComponent } from '../users.component';

@Component({
  selector: 'app-users-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})

export class UsersListComponent implements OnInit {

  data = [];
  cols = [
    { width: '5%', header: `Id`, field: 'id' },
    { width: '23%', header: `Login`, field: 'login' },
    { width: '17%', header: `Imię i nazwisko`, field: 'name' },
    { width: '10%', header: `Najemca`, field: 'companyName' },
    { width: '10%', header: `Telefon`, field: 'telephone' },
    { width: '23%', header: `E-mail`, field: 'email' },
  ];

  constructor(
    private utils: Utils,
    private messageService: MessageService,
    private administrationService: AdministrationService,
    public parent: UsersComponent
  ) { }

  ngOnInit() {
    this.administrationService.getAllUsers()
      .subscribe(
        users => {
          this.data = this.data.concat(users);
        },
        error => {
        }
      );
  }

  deleteUser(user: User): void {
    if (confirm('Czy chcesz dezaktywować użytkownika?')) {
      user.active = false;
      this.administrationService.createOrUpdate(user)
        .subscribe(
          () => {
            this.administrationService.getAllUsers()
              .subscribe(users => this.data = users || []);
            this.messageService.add({ severity: 'success', summary: 'Użytkownik został usunięty' });
          }, error => {
            //console.error(this.utils.handleError(error));
            this.messageService.add({ severity: 'error', summary: 'Użytkownik nie został usunięty', detail: this.utils.handleError(error) });
          }
        );
    }
  }
}
